import { Cluster } from '@cast/types';
import { toBig } from '@cast/utils';

import { enhanceClusterSummary } from '@cast/shared-cost-data-access';

export const getDiscoveredMetricsFromCluster = (
  cluster: Cluster
): ReturnType<typeof enhanceClusterSummary> => {
  const tags = cluster.tags;
  if (!tags) {
    return undefined;
  }

  const zero = toBig(0);

  const normalizedSummary = {
    clusterId: cluster.id,
    clusterScore: '',
    nodeCountOnDemand: toBig(tags['cloud-discovery-on-demand-node-count']),
    nodeCountSpot: toBig(tags['cloud-discovery-spot-node-count']),
    nodeCountSpotFallbackCastai: zero,
    nodesCountTotal: zero,
    cpuAllocatableTotal: zero,
    cpuRequestedTotal: zero,
    cpuProvisionedTotal: zero,
    cpuCostHourlyTotal: zero,
    ramAllocatableTotal: zero,
    ramRequestedTotal: zero,
    ramProvisionedTotal: zero,
    gpuProvisionedTotal: zero,
    gpuAllocatableTotal: zero,
    gpuUsedTotal: zero,
    gpuRequestedTotal: zero,
    nodesCountManagedTotal: zero,
    nodeCountOnDemandCastai: zero,
    nodeCountSpotCastai: zero,
    cpuProvisionedOnDemand: zero,
    cpuProvisionedSpot: zero,
    cpuProvisionedSpotFallback: zero,
    cpuAllocatableOnDemand: toBig(tags['cloud-discovery-cpu']),
    cpuAllocatableSpot: zero,
    cpuAllocatableSpotFallback: zero,
    cpuRequestedOnDemand: zero,
    cpuRequestedSpot: zero,
    cpuRequestedSpotFallback: zero,
    ramProvisionedOnDemand: zero,
    ramProvisionedSpot: zero,
    ramProvisionedSpotFallback: zero,
    ramAllocatableOnDemand: toBig(tags['cloud-discovery-memory-mib']).div(1024),
    ramAllocatableSpot: zero,
    ramAllocatableSpotFallback: zero,
    ramRequestedOnDemand: zero,
    ramRequestedSpot: zero,
    ramRequestedSpotFallback: zero,
    costHourlyOnDemand: zero,
    costHourlySpot: zero,
    costHourlySpotFallback: zero,
    podCount: zero,
    unschedulablePodCount: zero,
    cpuUsed: zero,
    ramUsed: zero,
    unknownNodeCount: zero,
    cpuCostHourlyOnDemand: toBig(tags['cloud-discovery-cpu-hourly-cost-usd']),
    cpuCostHourlySpot: zero,
    cpuCostHourlySpotFallback: zero,
    ramCostHourlyOnDemand: zero,
    ramCostHourlySpot: zero,
    ramCostHourlySpotFallback: zero,
    gpuProvisionedOnDemand: zero,
    gpuProvisionedSpot: zero,
    gpuProvisionedSpotFallback: zero,
    gpuAllocatableOnDemand: zero,
    gpuAllocatableSpot: zero,
    gpuAllocatableSpotFallback: zero,
    gpuRequestedOnDemand: zero,
    gpuRequestedSpot: zero,
    gpuRequestedSpotFallback: zero,
    gpuCostHourlyOnDemand: zero,
    gpuCostHourlySpot: zero,
    gpuCostHourlySpotFallback: zero,
    gpuUsedOnDemand: zero,
    gpuUsedSpot: zero,
    gpuUsedSpotFallback: zero,
    gpuIdleOnDemand: zero,
    gpuIdleSpot: zero,
    gpuIdleSpotFallback: zero,
    gpuNotUsedOnDemand: zero,
    gpuNotUsedSpot: zero,
    gpuNotUsedSpotFallback: zero,
    tpuAllocatableOnDemand: zero,
    tpuAllocatableSpot: zero,
    tpuAllocatableSpotFallback: zero,
    tpuCostHourlyOnDemand: zero,
    tpuCostHourlySpot: zero,
    tpuCostHourlySpotFallback: zero,
    tpuProvisionedOnDemand: zero,
    tpuProvisionedSpot: zero,
    tpuProvisionedSpotFallback: zero,
    tpuRequestedOnDemand: zero,
    tpuRequestedSpot: zero,
    tpuRequestedSpotFallback: zero,
    storageProvisioned: zero,
    storageRequested: zero,
    storageClaimed: zero,
    storageCostHourly: zero,
    scheduledPodsCount: zero,
  };

  return enhanceClusterSummary(normalizedSummary);
};
